export default __webpack_public_path__ + "static/premio_home-CO-addc505b53e6cc4f80117a032571eb01.png";